import React, { useState } from "react";
import axios from "axios";
import "../Styles/Contact.css";

function Contact() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      console.log("Sending enquiry to backend:", formData);

      const response = await axios.post(
        "http://localhost:8080/api/enquiries",
        formData
      );

      console.log("Backend response:", response.data);

      alert("Thank you! Your enquiry has been submitted successfully.");

      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      });

    } catch (error) {

      console.error("Error submitting enquiry:", error);

      if (error.response) {
        console.error("Backend status:", error.response.status);
        console.error("Backend data:", error.response.data);
      }

      alert("Unable to submit enquiry. Please check the backend.");

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">

      <h1>Contact Us</h1>

      <div className="contact-container">

        {/* LEFT SIDE - CONTACT DETAILS */}
        <div className="contact-info">

          <h2>🛕 Nambooriyachan Aal</h2>

          <div className="info-item">
            <h3>📍 Location</h3>

            <p>
              North Paravoor, Ernakulam.
              <br />
              The deity is situated beneath a sacred Banyan Tree
              in an open and accessible space.
              <br />
              Devotees are welcome to have darshan and offer prayers
              24 hours a day.
            </p>
          </div>

          <div className="info-item">
            <h3>📞 Phone</h3>

              <p>
             
              Madhu P   : 9388635662
              
            </p>
              <p>
                Sanalkumar M.C    : 9447391224
              </p>
              <p>
              Santhoshkumar V.N : 9961737313
            
            </p>
            
          </div>

          <div className="info-item">
            <h3>✉️ Email</h3>

            <p>
              <a href="mailto:yourtemple@email.com">
                Namboorichanal@gmail.com
              </a>
            </p>
          </div>

          {/* MAP */}
          <div className="map-container">

            <iframe
              src="https://www.google.com/maps?q=10.1486066,76.2287131&z=17&output=embed"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Nambooriyachan Aal Location"
            ></iframe>

          </div>

          <a
            href="https://www.google.com/maps/place/Nambooriyachan+Aal/@10.149289,76.2279089"
            target="_blank"
            rel="noopener noreferrer"
            className="direction-btn"
          >
            📍 Get Directions
          </a>

        </div>

        {/* RIGHT SIDE - ENQUIRY FORM */}
        <div className="enquiry-form">

          <h2>✉️ Send Us an Enquiry</h2>

          <p className="form-intro">
            If you have any questions, suggestions or enquiries,
            please feel free to contact us.
          </p>

          <form onSubmit={handleSubmit}>

            <div className="form-group">
              <label>Sender Name</label>

              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>

              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
            </div>

            <div className="form-group">
              <label>Subject</label>

              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Enter subject"
                required
              />
            </div>

            <div className="form-group">
              <label>Message / Enquiry</label>

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter your message or enquiry"
                rows="6"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="send-btn"
              disabled={loading}
            >
              {loading ? "Sending..." : "📤 Send Message"}
            </button>

          </form>

        </div>

      </div>

    </div>
  );
}

export default Contact;